module.exports = __webpack_public_path__ + "img/3.963ab58e.png";